import gql from 'graphql-tag';

export default gql`
  query inventoryNotes($moduleName: String, $selectedRow: InventoryRowInput) {
    inventoryNotes(moduleName: $moduleName, selectedRow: $selectedRow) {
      NotesVar
      NotesTast
      NotesVine
      NotesVinif
      NotesProd
      NotesAge
      NotesSoil
      NotesOrien
      NotesViti
    }
  }
`;
